import { render, staticRenderFns } from "./SwitchAccountPassword.vue?vue&type=template&id=97f740f0&scoped=true"
import script from "./SwitchAccountPassword.vue?vue&type=script&lang=js"
export * from "./SwitchAccountPassword.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccountPassword.vue?vue&type=style&index=0&id=97f740f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f740f0",
  null
  
)

export default component.exports